import { TextField } from "@mui/material";
import styles from "./AddNewCategory.module.css";
import { useEffect, useState } from "react";
import store from "../../../Store/Store";
import axios from "axios";
import config from "../../../config/config";
const AddNewCategory = ({ isVisible, setClose, NewCategoryAdded }) => {
  const [ErrorMessage, setErrorMessage] = useState("");
  const [CategoryName, setCategoryName] = useState("");
  const [Description, setDescription] = useState("");
  const [errormsg, setErrorMsg] = useState({
    InValidCatname: false,
    categoryLength: false,
    InvalidDescription: false,
    DescriptionLength: false,
  });

  var logAddCategoryVisited;
  var logAddCategoryAdded;
  try {
    logAddCategoryVisited = useDebouncedLog("admin_add_category_visited", 500);
    logAddCategoryAdded = useDebouncedLog("admin_add_category_added", 500);
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    console.log("store.Company_Id", store.Company_Id);
  }, [logAddCategoryVisited]);

  const onFrameButtonClick = async () => {
    if (CategoryName.trim().length < 1) {
      console.log("this is no category");
      //Error Message
      setErrorMessage("Category Name Field cannot be empty.");
      setErrorMsg((prev) => ({ ...prev, InValidCatname: true }));

      return;
    }
    if (errormsg.InValidCatname) {
      return;
    }
    if (CategoryName.trim().length > 100) {
      console.log("this is Invalid category");
      //Error Message
      return;
    }
    if (Description.trim().length > 100) {
      console.log("this is Invalid Description");
      //Error Message
      return;
    }
    if (Description.trim().length > 100) {
      console.log("this is Invalid Description");
      //Error Message
      return;
    }

    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    console.log("CLICKED");
    let obj = {
      category_name: CategoryName, //max_length 100 character, Special Characters allowed: - _ / ( ) Space
      category_description: Description, //max_length 100 charachter //All special characters Should be allowed
      ledger_label: store.Company_Id,
    };

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/create_category`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then(() => {
        setClose();
        NewCategoryAdded();
        try {
          logAddCategoryAdded();
        } catch (err) {
          console.log("error", err);
        }
      })
      .catch((err) => {
        console.log("error %o", err);
        const errorBody = err?.response?.data?.data;

        if (
          typeof errorBody === "string" &&
          errorBody.startsWith("Category Already Exists :")
        ) {
          // → this is the "category already exists" error
          setErrorMessage("This Category already Exists.");
          setErrorMsg((prev) => ({
            ...prev,
            InValidCatname: true,
          }));
          console.log("Category already exists!==============");
        }
      });
  };

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles.frameGroup}
        onClick={() => {
          setClose();
        }}
      >
        <img className={styles.arrowNarrowLeftIcon} alt="" src="/xclose.svg" />
      </div>
      <div className={styles.frameParent1}>
        <div className={styles.frameHeading}>Add a Category</div>
        <div className={styles.frameWrapper}>
          <div className={styles.mobileMenuParent}>
            <div className={styles.mobileMenuParent}>
              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={CategoryName}
                  label="Enter Category Name"
                  required
                  onChange={(e) => {
                    const newValue = e.target.value;

                    setErrorMessage("");
                    setErrorMsg((prev) => ({ ...prev, InValidCatname: false }));

                    // Allow empty string + allow shortening (deletion)
                    if (
                      newValue === "" ||
                      newValue.length < CategoryName.length
                    ) {
                      setCategoryName(newValue);
                      return;
                    }

                    // From here: only new characters / longer input
                    if (newValue.length > 100) {
                      setErrorMessage("Maximum 100 characters allowed");
                      setErrorMsg((prev) => ({
                        ...prev,
                        InValidCatname: true,
                      }));
                      return;
                    }

                    setCategoryName(newValue);
                    const regex = /^[a-zA-Z0-9\-_()\/ ]+$/;
                    if (!regex.test(newValue)) {
                      setErrorMessage(
                        "Category Name cannot contain this special character.",
                      );
                      setErrorMsg((prev) => ({
                        ...prev,
                        InValidCatname: true,
                      }));
                      return;
                    }

                    if (newValue.length >= 100) {
                      setErrorMessage("Maximum Character Length Reached");
                      setErrorMsg((prev) => ({
                        ...prev,
                        categoryLength: true,
                      }));
                      return;
                    } else {
                      setErrorMsg((prev) => ({
                        ...prev,
                        categoryLength: false,
                      }));
                    }
                  }}
                  variant="outlined"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": { minHeight: "56px" },
                  }}
                  InputProps={{
                    style: { borderRadius: ".45rem" },
                  }}
                />

                {errormsg.InValidCatname && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
                {errormsg.categoryLength && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>

              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={Description}
                  label="Enter Description"
                  onChange={(e) => {
                    const value = e.target.value;

                    // Clear previous errors
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      InvalidDescription: false,
                      // ... other flags you want to clear
                    }));

                    if (value.length >= 100) {
                      setErrorMessage("Maximum 100 characters allowed");
                      setErrorMsg((prev) => ({
                        ...prev,
                        InvalidDescription: true,
                      }));
                      return;
                    }

                    setDescription(value);
                  }}
                  variant="outlined"
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": { minHeight: "56px" },
                  }}
                  InputProps={{
                    style: { borderRadius: ".45rem" },
                  }}
                />

                {errormsg.InvalidDescription && (
                  <div className={styles.errorDiv}>
                    <div className={styles.error}>{ErrorMessage}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.GreayedText}>
          Note: Once this category is added, it cannot be edited or removed. You
          can however disable it anytime.
        </div>
        <div
          className={styles.frameDiv}
          onClick={async () => {
            await onFrameButtonClick();
            // await new Promise(resolve => setTimeout(resolve, 1000));
          }}
        >
          <div className={styles.loadsButtonsWrapper}>
            <div className={styles.loadsButtons}>
              <b className={styles.submit}>Submit</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNewCategory;
